import {AssetsRequestParams} from "../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../app/consts";

export class BetsImageRequestParams extends AssetsRequestParams {
  constructor() {
    super();
    this.resourceName = `${this.resourceName}/Odds`;
    this.ratio = 1;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
